import { Clock, Ban, AlertCircle } from 'lucide-react';
import LogoSynosight from '../assets/synosight-logo-horizontal.svg';
import { currentPathForLogin } from '../lib/routes.js';

const ALLOWED_DOMAINS = ['synotis.ch', 'synotis.com', 'smile.eu', 'smile.fr', 'smile-maroc.com'];

function classifyAuthError(msg) {
  if (!msg) return null;
  const lower = msg.toLowerCase();
  if (lower.includes('attente') || lower.includes('pending')) return 'pending';
  if (lower.includes('désactivé') || lower.includes('desactive') || lower.includes('disabled')) return 'disabled';
  return 'generic';
}

// Work item #11 — on repasse l'écran courant en `next` : une session expirée
// sur `/prospection` revient sur `/prospection`, pas sur l'accueil.
export default function LoginView({ onLogin, authError }) {
  const kind = classifyAuthError(authError);
  const ErrorIcon = kind === 'pending' ? Clock : kind === 'disabled' ? Ban : AlertCircle;
  const errorTitle =
    kind === 'pending' ? "Compte en attente d'activation"
    : kind === 'disabled' ? 'Compte désactivé'
    : "Erreur d'authentification";
  const errorDetail =
    kind === 'pending'
      ? "Votre compte a été créé mais un administrateur doit le valider avant que vous puissiez accéder à l'application."
    : kind === 'disabled'
      ? 'Votre compte a été désactivé. Contactez un administrateur pour le réactiver.'
    : authError;

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        gap: '2rem',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          background: '#fff',
          borderRadius: 22,
          padding: '32px 48px',
          boxShadow: 'var(--shadow-card)',
        }}
      >
        <img src={LogoSynosight} alt="Synosight" style={{ height: 128, width: 'auto', display: 'block' }} />
      </span>

      <p style={{ color: 'var(--text-muted)', textAlign: 'center', maxWidth: 480 }}>
        Connectez-vous avec votre compte Google pour visualiser le taux d'occupation
        prévisionnel des collaborateurs.
      </p>

      {authError && (
        <div
          role="alert"
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.6rem',
            background: kind === 'pending'
              ? 'rgba(245, 158, 11, 0.1)'
              : 'rgba(239, 68, 68, 0.1)',
            border: `1px solid ${kind === 'pending' ? 'var(--warning)' : 'var(--danger)'}`,
            color: kind === 'pending' ? 'var(--warning)' : 'var(--danger)',
            padding: '0.85rem 1rem',
            borderRadius: 'var(--radius-md)',
            maxWidth: 480,
          }}
        >
          <ErrorIcon size={18} style={{ flexShrink: 0, marginTop: 2 }} />
          <div style={{ color: 'var(--text)' }}>
            <strong>{errorTitle}</strong>
            <div style={{ marginTop: 4, color: 'var(--text-muted)', fontSize: '0.9rem' }}>
              {errorDetail}
            </div>
          </div>
        </div>
      )}

      <button
        onClick={() => onLogin(currentPathForLogin())}
        style={{
          background: '#4285F4',
          color: '#fff',
          border: 'none',
          padding: '0.85rem 1.75rem',
          borderRadius: 'var(--radius-sm)',
          fontSize: '1rem',
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(66, 133, 244, 0.3)',
          display: 'flex',
          alignItems: 'center',
          gap: '0.6rem',
        }}
      >
        <svg width="18" height="18" viewBox="0 0 18 18">
          <path fill="#fff" d="M16.51 8.18c0-.55-.05-1.08-.14-1.59H9v3h4.21c-.18.97-.74 1.79-1.58 2.34v1.95h2.55c1.5-1.38 2.33-3.42 2.33-5.7z" />
          <path fill="#fff" d="M9 17c2.13 0 3.92-.71 5.22-1.92l-2.55-1.95c-.71.48-1.62.76-2.67.76-2.06 0-3.8-1.39-4.42-3.26H2v2.02C3.3 15.32 6.95 17 9 17z" />
          <path fill="#fff" d="M4.58 10.63A5.27 5.27 0 014.31 9c0-.57.1-1.13.27-1.63V5.34H2A8.99 8.99 0 001 9c0 1.45.35 2.83.97 4.04l2.61-2.41z" />
          <path fill="#fff" d="M9 4.74c1.16 0 2.2.4 3.02 1.18l2.26-2.26C12.93 2.41 11.14 1.6 9 1.6 6.95 1.6 3.3 3.28 2 5.34l2.58 2.03C5.2 6.13 6.94 4.74 9 4.74z" />
        </svg>
        Se connecter avec Google
      </button>

      <div
        style={{
          color: 'var(--text-muted)',
          fontSize: '0.85rem',
          textAlign: 'center',
          maxWidth: 480,
        }}
      >
        Seuls les comptes des domaines{' '}
        <strong style={{ color: 'var(--text)' }}>{ALLOWED_DOMAINS.join(', ')}</strong>{' '}
        peuvent accéder à cette application.
      </div>
    </div>
  );
}
